"use strict";

angular.module("models").service("ElearningTemplatesService", ["ApiService", function (ApiService) {
  var that = this;

  angular.extend(that, ApiService.getModel("elearningTemplates", ["name"], function (element) {
    return "???";
  }));
}]);